import copy from 'clipboard-copy';

const onCopyClick = function () {
    // rt/rp 要素 (ルビ・フリガナ) を除外してテキストを取得する。
    // 例: <ruby>田中<rt>たなか</rt></ruby> をコピーすると「田中」だけになる。
    // a68c181a の jQuery 撤去時に取りこぼした処理を復元 (元 1ef10481)。
    const clone = this.cloneNode(true);
    clone.querySelectorAll('rt, rp').forEach((el) => el.remove());
    const content = clone.textContent?.replace(/\s+/g, ' ').trim();
    copy(content).then(() => window.flash(`クリップボードに「${content}」をコピーしました`));
};

window.enableCopy = () => {
    document.querySelectorAll('.clipboard-copy').forEach((el) => {
        // AJAX 後に enableCopy() が再度呼ばれても同じ要素にハンドラが二重登録
        // されないよう、先に removeEventListener しておく (同じ関数参照なので確実に剥がれる)
        el.removeEventListener('click', onCopyClick);
        el.addEventListener('click', onCopyClick);
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.enableCopy);
} else {
    window.enableCopy();
}
